import React, { createContext, useContext, useState } from 'react';

const FormContext = createContext();

export function useFormContext() {
  return useContext(FormContext);
}

export function FormProvider({ children }) {
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [formType, setFormType] = useState('');
  const [formMessage, setFormMessage] = useState('');

  const value = {
    isFormDirty,
    setIsFormDirty,
    formType,
    setFormType,
    formMessage,
    setFormMessage
  };

  return (
    <FormContext.Provider value={value}>
      {children}
    </FormContext.Provider>
  );
}
